import * as React from 'react';
import { EActiveView } from '../../types/view';
import { Title } from '../../_NEXT_components/Title';
import { EActiveFlow } from '../../types/flow';
import { ESentEmailType } from '../../types/sentEmail';
export function TitleContainer(_ref) {
  var currentView = _ref.currentView,
      viewData = _ref.viewData,
      flow = _ref.flow,
      indent = _ref.indent;
  var title = React.useMemo(function () {
    switch (currentView) {
      case EActiveView.AuthenticationRegistration:
        if (!flow) {
          return 'Вход и регистрация';
        }

        return flow === EActiveFlow.Authentication ? 'Вход' : 'Регистрация';

      case EActiveView.AccountSelect:
      case EActiveView.ConfirmSelectedAccount:
      case EActiveView.TokenExpiredError:
      case EActiveView.AccountSelectError:
        return 'Вход';

      case EActiveView.PhoneAuth:
      case EActiveView.PhoneAuthValidateSms:
      case EActiveView.PhoneAuthValidateCall:
        return 'Вход по телефону';

      case EActiveView.Agreement:
        return 'Дайте согласие, чтобы продолжить';

      case EActiveView.PhoneCallOnboarding:
        return 'Мы сейчас позвоним вам, не берите трубку';

      case EActiveView.ConfirmPhone:
        return 'Подтверждение телефона';

      case EActiveView.EmailSent:
        if (viewData.type === ESentEmailType.Registration) {
          return 'Завершение регистрации';
        } else {
          return 'Восстановление пароля';
        }

      case EActiveView.TwoFactor:
      case EActiveView.TwoFactorWithEmail:
        return 'Подтверждение входа';

      case EActiveView.TwoFactorAttemptsExhausted:
        return 'Ошибка входа';

      case EActiveView.Restore:
        return 'Восстановление пароля';

      case EActiveView.SocialCreate:
        return 'Завершение регистрации';

      case EActiveView.SocialMerge:
        return 'Объединение аккаунтов';

      default:
        return null;
    } // eslint-disable-next-line react-hooks/exhaustive-deps

  }, [currentView, flow]);

  if (!title) {
    return null;
  }

  return /*#__PURE__*/React.createElement(Title, {
    indent: indent
  }, title);
}